/**
 * @file Mixin to response to window size for root vue app
 */
import { observeVisualViewportSize, observeWindowSize } from 'bits/window'
import debounce from 'lodash.debounce'
import { Component, Vue } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'

const browser = namespace('browser')

@Component
export default class extends Vue {
  unobserveWindowSize
  unobserveVisualViewportChange

  @State((state) => state.isTouchable) isDeviceTouchable!: boolean
  @browser.Action resizeWindow

  mounted(): void {
    this.resizeWindow({
      height: window.innerHeight,
      width: window.innerWidth,
    })
    this.unobserveWindowSize = observeWindowSize(debounce(this.resizeWindow, 250))

    // On some mobile browsers, e.g. Google Chrome on iOS, when the window resize event is fired on device orientation change,
    // the new width / height is not available in the resize event yet
    // Reference: - https://stackoverflow.com/questions/65648544/clientwidth-and-innerwidth-not-updating-on-ios-chrome-after-orientationchange
    //            - https://stackoverflow.com/questions/12452349/mobile-viewport-height-after-orientation-change
    // We should also check for visual viewport change, this would ensure the window has been resized
    if (this.isDeviceTouchable) {
      // We should only care about this if it's a touch device
      const handleVisualViewportChange = (): void => {
        this.resizeWindow({
          height: window.innerHeight,
          width: window.innerWidth,
        })
      }
      this.unobserveVisualViewportChange = observeVisualViewportSize(debounce(handleVisualViewportChange, 250))
    }
  }

  beforeDestroy(): void {
    this.unobserveWindowSize && this.unobserveWindowSize()
    this.unobserveVisualViewportChange && this.unobserveVisualViewportChange()
  }
}
